var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "#FFDFDF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.471 22.059L19.9478 17.5815L21.0413 20.364L11.7863 24L8.18025 14.8215L15.471 22.059ZM14.514 6H7.5V13.0898L15.4688 21L22.5 13.9688L14.514 6ZM17.5328 13.107C17.2215 12.7957 16.884 12.6442 16.4992 12.6442C16.0658 12.6442 15.579 12.825 14.871 13.2473C14.3595 13.5547 14.0325 13.6852 13.779 13.6852C13.5082 13.6852 12.9668 13.3793 13.0583 12.7718C13.0972 12.513 13.2457 12.249 13.4872 12.0068C13.9762 11.5185 14.6452 11.3707 15.1943 11.9272L15.7523 11.3692C15.3953 11.0122 14.9302 10.7752 14.4315 10.7752C14.007 10.7752 13.5878 10.9455 13.1843 11.283L12.7148 10.8127L12.1912 11.337L12.681 11.826C12.2543 12.4455 12.0495 13.3418 12.738 14.0295C13.4963 14.7878 14.379 14.4353 15.2978 13.8555C15.7478 13.5712 16.11 13.4333 16.404 13.4333C16.8457 13.4333 17.289 13.8067 17.2125 14.3767C17.1735 14.6663 17.0175 14.949 16.7467 15.2183C16.4085 15.5565 16.0688 15.7275 15.7365 15.7275C15.423 15.7275 15.1762 15.5835 14.9497 15.381L14.3955 15.9352C14.7428 16.2787 15.207 16.5 15.6967 16.5C16.1047 16.5 16.512 16.3492 16.9058 16.0522L17.3108 16.4557L17.8335 15.933L17.4435 15.5422C18.0008 14.8702 18.3112 13.8855 17.5328 13.107ZM10.2743 7.5C10.9777 7.5 11.5485 8.07075 11.5485 8.77425C11.5485 9.47775 10.9777 10.0485 10.2743 10.0485C9.57075 10.0485 9 9.47775 9 8.77425C9 8.07075 9.57075 7.5 10.2743 7.5Z",
    fill: "#F93131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSales);
export default __webpack_public_path__ + "static/media/sales.fdde79e940d8c341abe6f033d86547ee.svg";
export { ForwardRef as ReactComponent };